/* eslint-disable no-shadow */
import {ColorThemeType, FontThemeType} from '../../appStyles/style/type';

import {HiringApplicationState} from '@buncha/common/types/common';
import {ReactNode} from 'react';
import {ToastType} from '../../components/composites/notification/type';
import {TutorialsMode} from '@buncha/home/types';
import {WhenIWorkData} from '@buncha/config/graphQL/type';

export enum MapChoice {
  'appleMaps' = 'appleMaps',
  'googleMaps' = 'googleMaps',
  'none' = 'none',
}

export enum UserTypes {
  user = 'user',
  runOnwer = 'runOnwer',
  dispatcher = 'dispatcher',
  shopper = 'shopper',
  driver = 'driver',
  hiring = 'hiring',
}

export interface UserAuthData {
  smsCode?: string;
  phoneNumber?: string;
  loginToken?: string;
  createUserToken?: string;
  otpSent?: boolean;
  firstName?: string;
  lastName?: string;
  email?: string;
  wToken?: string;
}

export interface ChatUser {
  id: string;
  name: string;
  email: [string];
  phone: [string];
  photoUrl: string;
  role: string;
  welcomeMessage: string;
}
export interface UserStub {
  id?: number;
  firstName: string;
  lastName: string;
  avatar: string;
  email: string;
  phoneNumber: string;
  userTypes: string[];
  isActive: boolean;
  WhenIWorkInfo: WhenIWorkData;
  mapChoice: MapChoice;
  completedOrderCount: number;
  fullfillmentHiringApplicationState: {
    id: number;
    status: HiringApplicationState;
  };
  chatUser: ChatUser;
  tutorials: Tutorials[];
}

export interface Tutorials {
  id: number;
  name: TutorialsMode;
}

export interface OnBoardingState {
  currentUser?: UserStub;
  userAuthData?: UserAuthData;
  notificationToastInfo?: NotificationToastInfo;
  constants?: Constants;
  unreadMemoCount: number;
  unreadMemoModal: boolean;
  downTime: boolean;
}

export interface Constants {
  ITEM_UNITS: any;
  MAX_WEIGHT_FIELDS: any;
  SKIP_UPC_FLOW: string;
  ENABLED_ALL_DRIVER_TAB: string;
  ENABLE_PRICE_TAG_FLOW: string;
  PRINTER_LOCAL_NAME: string;
  STORE_IDS_FOR_UNABLE_TO_SCAN_OPTION_VISIBLE: string;
  CATEGORIES_FOR_UNABLE_TO_SCAN_OPTION_VISIBLE: string;
  SHOPPER_PERMISSIONS_ENABLED: string;
  PRINTER_ENABLED: string;
  MEIJER_STORE_IDS: string;
  PRINTER_MANAGE: string;
  B2B_STORE_IDS: string;
  ONFLEET_CONFIG_ID: string;
  B2B_STORE_MAPS: string;
  SHOPPER_ITEM_DESCRIPTION_BANNER: string;
  ONFLEET_LOGIN_DATA: string;
  DRIVER_FAILURE_OPTIONS: string;
  SHOW_ASSIGN_ORDERS: string;
  SMARTLOOK_ENABLE: string;
  DROP_MODAL_CONFIG: string;
  RETRY_CONFIG: string;
  FULFILLMENT_LOCALIZATION_VERSION: string;
  SHOW_STARTING_BAG_COUNT_MODAL: string;
  SKIP_B2B_UPC_FLOW?: string;
  ADJOOS_BANNER_CAROUSEL_ID: string;
  ALLOW_SHOPPER_NON_NSC_ITEM_MODAL?: string;
  WAIT_TIME_FOR_AOOS?: string;
  DEVELOPER_IDS?: string;
  AOOS_SNOOZE_TIMER?: string;
  ADJ_OOS_BACK_NAVIGATION?: string;
  CALL_DISABLED_USER_IDS?: string;
  AUTO_RESCHEDULE_TIMER?: string;
}

export interface NotificationToastInfo {
  show: boolean;
  details: NotificationToastDetails;
}

export interface NotificationToastDetails {
  title: string;
  duration?: number;
  colorThemeType?: ColorThemeType;
  fontThemeType?: FontThemeType;
  style?: any;
  containerStyle?: any;
  orientation?: string;
  type?: ToastType;
  /**
   * Leftside Icon to display
   */
  leftIcon?: ReactNode;
  /**
   * Rightside Icon to display
   */
  rightIcon?: ReactNode;
}

export interface RegisterShopperParams {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  createUserToken: string;
  userTypes: UserTypes[];
}

export interface ModalDetails {
  header?: string;
  subheader?: string;
  topCTA?: string;
  bottomCTA?: string;
}
